<ion-header>
    <ion-toolbar>
        <ion-title>Aceptar Referido</ion-title>
        <ion-buttons slot="end">
            <ion-button color="dark" (click)="closeModal()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <app-form [questions]="questions"></app-form>
    <button class="z-depth-2 smallButton horizontalCenter" (click)="saveResult()">Aceptar</button>
</ion-content>
